import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ark-lib-page-content',
  templateUrl: './page-content.component.html',
  styleUrls: ['./page-content.component.css'],
})
export class PageContentComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
